// Basic
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Lang
import { nsSubscription } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.directProviderLegalName
 * @param root0.directProviderLabel
 * @param root0.directProviderUuid
 * @returns {JSX} RenderSubscriptionDirectProvider
 */
function RenderSubscriptionDirectProvider({ directProviderLegalName, directProviderUuid }) {

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);

    return (
        <TooltipHelper
            triggerClass='max-w-48'
            trigger={
                <div>
                    {directProviderLegalName ?
                        <div className='text-left block whitespace-nowrap overflow-hidden text-ellipsis'>
                            {directProviderLegalName}
                        </div>
                        : null}
                    {
                        rootOrganization.uuid && directProviderUuid && rootOrganization.uuid === directProviderUuid ?
                            <small>
                                <Entity entity='text.is_direct' namespace={nsSubscription} />
                            </small>
                            : false
                    }
                </div>}
            content={<Entity entity={directProviderLegalName} />}
        />
    );
}

RenderSubscriptionDirectProvider.propTypes = {
    directProviderLegalName: PropTypes.string,
    directProviderUuid: PropTypes.string
};

export default RenderSubscriptionDirectProvider;
